export const iconFontAwesomeFoodBeverageCookie = (
	<i className="fa-solid fa-cookie"></i>
);
